import { FeedItem } from '../../types/feed.types';
import MediaCard from '../cards/v2/media.card';
import SocialCard from '../cards/v2/social.card';
import { VStack } from '../layouts/stack.layout';
import { v4 as uuid4 } from 'uuid';
import { dateSort } from '../../utils/common.util';
import { feedsState } from '../../recoil/feeds/feeds.state';
import { useRecoilValue } from 'recoil';

// Avoid passing props, feed container should just load feeds by its self
type FeedsContainerProps = {
  query?: FeedQuery[]; // the query to be used when this component is rendered
  params?: { [key in 'id']: string };
};

export default function FeedsContainer(props: FeedsContainerProps) {
  const { query, params } = props;

  const data: FeedItem[] = [];

  // temporary data querying from local data store
  if (query) {
    for (const q of query) {
      if (params) data.push(...GET[q](params.id));
      else data.push(...GET[q]());
    }
  }

  const sortedFeeds = [...data].sort(
    ({ date: dateA }: FeedItem, { date: dateB }: FeedItem) =>
      dateSort(dateA, dateB)
  );

  return (
    <VStack gap="base" extensions="mobile:px-2 tablet-lg:px-[40px] py-2">
      {sortedFeeds.map((feed) => (
        <span className="w-full feed-card-wrapper" key={uuid4()}>
          {feed.category === 'news' && <MediaCard key={feed.id} data={feed} />}
          {feed.category !== 'news' && <SocialCard key={feed.id} data={feed} />}
        </span>
      ))}
    </VStack>
  );
}

type FeedQuery =
  | 'SOCIAL_FEEDS'
  | 'HOLDR_FEEDS'
  | 'NEWS_FEEDS'
  | 'ALL_FEEDS'
  | 'BOOKMARKS';

type FeedQueryMap = { [key in FeedQuery]: Function };

const GET: FeedQueryMap = {
  SOCIAL_FEEDS: (param: string): FeedItem[] => {
    const feedData = useRecoilValue(feedsState);

    if (param) {
      return feedData.filter(
        (feed) => feed.username === param && feed.category === 'social'
      );
    } else {
      return feedData.filter((feed) => feed.category === 'social');
    }
  },
  HOLDR_FEEDS: (param: string): FeedItem[] => {
    const feedData = useRecoilValue(feedsState);
    // The graphql query to actually be called is rendered here
    // with its param
    if (param) {
      return feedData.filter(
        (feed) => feed.username === param && feed.category === 'holdr'
      );
    } else {
      return feedData.filter((feed) => feed.category === 'holdr');
    }
  },
  NEWS_FEEDS: (param: string): FeedItem[] => {
    const feedData = useRecoilValue(feedsState);
    // The graphql query to actually be called is rendered here
    // with its param
    if (param) {
      return feedData.filter(
        (feed) => feed.artist === param && feed.category === 'news'
      );
    } else {
      return feedData.filter((feed) => feed.category === 'news');
    }
  },
  ALL_FEEDS: (): FeedItem[] => {
    const feedData = useRecoilValue(feedsState);
    // The graphql query to actually be called is rendered here
    return feedData.filter((feed) => feed.artist);
  },
  BOOKMARKS: (): FeedItem[] => {
    const feedData = useRecoilValue(feedsState);

    const bookmarkedFeeds = [...feedData].filter((feed) => feed.bookmarked);

    return bookmarkedFeeds;
  },
};
